// MEGA MENU
// function mmMegaMenuShowProducts(classElemsToHide, classElemToShow) {
//   var imageContainers = document.querySelectorAll(classElemsToHide);
//   imageContainers.forEach(function(imageContainer){
//     imageContainer.style.display = 'none';
//   })
//   document.querySelector(classElemToShow).style.display = 'grid';
// }

function getMegaMenuPosition(){
	var menuElems = document.querySelectorAll('.mm-header-link');
	var header = document.querySelector('.mm-header-bottom');
	var headerHeight = header.offsetHeight - 1;

	menuElems.forEach(function(menuElem) {
		if (menuElem.nextElementSibling) {
			if (menuElem.nextElementSibling.classList.contains('mm-mega-menu-wrapper')) {
				menuElem.nextElementSibling.style.top = `calc(${headerHeight}px)`;
			}
		}
	})
}

document.addEventListener("DOMContentLoaded", (event) => {
	getMegaMenuPosition();
});

// MOBILE MENU
function mmMobileMenu() {
    const header = document.querySelector("header");
    const icon = document.querySelector(".mm-header-burger .burger");
    const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");

    header.classList.toggle("mm-open");
    icon.classList.toggle("mm-open");
    mobileMenu.classList.toggle("mm-menu-open");

    if (header.classList.contains('mm-open')) {
		document.querySelector("html").classList.add("stop-scrolling");
		document.querySelector("body").classList.add("stop-scrolling");
    } else {
		document.querySelector("html").classList.remove("stop-scrolling");
		document.querySelector("body").classList.remove("stop-scrolling");
    }

    // sous menu drawer
    var sousMenuDrawers = header.querySelectorAll(".mm-mega-menu-mobile-wrapper");
    sousMenuDrawers.forEach((element) => {
		element.classList.remove('mm-open');
    });
}

// Sous-Menu Mobile
function mmMobileMenuShowNext(elemToShowClass) {
	var elemToShow = document.querySelector(elemToShowClass);
	elemToShow.classList.add('mm-open');
}

function mmMobileMenuShowPrev(elemToShowClass) {
	var elemToShow = document.querySelector(elemToShowClass);
	elemToShow.classList.remove('mm-open');
}

// Slider header drawer mobile
var splideDrawerMobile = document.querySelector(".splide-header-drawer-mobile");
if (splideDrawerMobile) {
	var bar = splideDrawerMobile.querySelector(".my-carousel-progress-bar");
	document.addEventListener("DOMContentLoaded", function () {
		var headerSplide = new Splide(splideDrawerMobile, {
			type: "slide",
			arrows: false,
			pagination: false,
			gap: 15,
			perPage: 1,
			omitEnd: true,
		}).mount();

		headerSplide.on("mounted move", function () {
			var end = headerSplide.Components.Controller.getEnd() + 1;
			var rate = Math.min((headerSplide.index + 1) / end, 1);
			bar.style.width = String(100 * rate) + "%";
		});
	});
}

class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement("div");
                    html.innerHTML = text;
                    const recommendations = html.querySelector("product-recommendations");

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                    }

                })
                .catch((e) => {
                    console.error(e);
                });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
    }
}

customElements.define("product-recommendations", ProductRecommendations);

function animatedDropdowns(){
	const faqColl = document.querySelectorAll('.mm-faq-collapsible');
	let q;

	for (q = 0; q < faqColl.length; q++) {
		faqColl[q].addEventListener('click', function () {
			this.classList.toggle('active');

			const content = this.nextElementSibling;

			if (content.style.maxHeight) {
				content.style.maxHeight = null;
			} else {
				content.style.maxHeight = content.scrollHeight + 'px';
			}
		});
	}
}

window.addEventListener("DOMContentLoaded", (event) => {
	animatedDropdowns();
});

/* mobile drawer height */
const documentHeight = () => {
	const doc = document.documentElement
	doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
}

window.addEventListener('resize', documentHeight)
documentHeight()

/* Countdown header desktop */
var countdownText = document.getElementById("mm-header-countdown");

if (countdownText) {
	function updateTimer() {
		var dateActuelle = new Date();
		var dateToCount = new Date(dateActuelle.getFullYear(), dateActuelle.getMonth(), dateActuelle.getDate() + 1, 10, 0, 0);
		var tempsRestant = dateToCount - dateActuelle;

		var heuresRestantes = Math.floor((tempsRestant % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		var minutesRestantes = Math.floor((tempsRestant % (1000 * 60 * 60)) / (1000 * 60));
		var secondesRestantes = Math.floor((tempsRestant % (1000 * 60)) / 1000);

			heuresRestantes = heuresRestantes < 10 ? "0" + heuresRestantes : heuresRestantes;
			minutesRestantes = minutesRestantes < 10 ? "0" + minutesRestantes : minutesRestantes;
			secondesRestantes = secondesRestantes < 10 ? "0" + secondesRestantes : secondesRestantes;
		var texteModifie = `<span class="mm-countdown-hours">${heuresRestantes}</span>
						<span class="mm-countdown-separator"> : </span>
						<span class="mm-countdown-minutes">${minutesRestantes}</span>
						<span class="mm-countdown-separator"> : </span>
						<span class="mm-countdown-secondes">${secondesRestantes}</span>`;

		countdownText.innerHTML = texteModifie;

		tempsRestant -= 1000;
	}

	setInterval(updateTimer, 1000);
	updateTimer();
}

// test quantity product card
function mmChangeQtty(delta, inputId) {
	var input = document.getElementById(inputId);
	if (delta == "-1" && input.value == "1") {
	} else {
		var newValue = parseInt(input.value, 10) + parseInt(delta, 10);
		input.value = newValue;
	}
}


// GSAP
document.addEventListener("DOMContentLoaded", (event) => {
	// Enregistrement du plugin ScrollTrigger
	gsap.registerPlugin(ScrollTrigger);

	const lenis = new Lenis({
		duration: 1,
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
		direction: "vertical",
		gestureDirection: "vertical",
		lerp: 0.0035,
		smooth: 2,
		smoothTouch: false,
		touchMultiplier: 2,
		wheelMultiplier: 1,
		infinite: false,
		autoResize: true
	});

	lenis.on("scroll", ({scroll, limit, velocity, direction, progress}) => {});
	function raf(time) {
		lenis.raf(time);
		requestAnimationFrame(raf);
		ScrollTrigger.update();
	}
	requestAnimationFrame(raf);


  //card parallax effect
	const imageContainers = document.querySelectorAll(".slide-image-cover-container");
	// Paralax
	if(imageContainers) {
		imageContainers.forEach((imageContainer) => {
			gsap.to(imageContainer, {
				yPercent: 20,
				ease: "none",
				scrollTrigger: {
				trigger: imageContainer.parentNode, // Utilisation du parent comme déclencheur
				start: "top bottom",
				end: "bottom top",
				scrub: true
				}
			});
		});
	}
});

// Animation du strokeDashoffset au scroll
const patterns = document.querySelectorAll(".pattern");
// Paralax
document.addEventListener("DOMContentLoaded", (event) => {
	if(patterns) {
		patterns.forEach((pattern) => {
			gsap.to(pattern, {
				"--svg-offset": "0",
				scrollTrigger: {
				trigger: pattern,
				start: "top bottom",
				end: "bottom top",
				scrub: true
				}
			});
		});
	}
});

// Animation du mangoustan
const mangoustans = document.querySelectorAll(".mangoustan");

// Paralax
document.addEventListener("DOMContentLoaded", (event) => {
	if (mangoustans) {
		mangoustans.forEach((mangoustan) => {
			gsap.to(mangoustan, {
				rotate: "90deg",
				scrollTrigger: {
				trigger: mangoustan,
				start: "top bottom",
				end: "bottom top",
				scrub: true
				}
			});
		});
	}
})

/* Product cards variant selector */
function initializeVariantSelectors() {
	const variantSelectorAll = document.querySelectorAll(".mm-pc-variants-selector-container");
	variantSelectorAll.forEach( (variantSelector) => {
		variantSelector.addEventListener("change", (event) => {
			const selectedVariant = event.target.options[event.target.selectedIndex];
			const selectedId = selectedVariant.value;
			const productCard = variantSelector.closest(".mm-product-card")

			console.log(selectedVariant);
			//change CTA variant id
			productCard.dataset.variantId = selectedId;

			//change price
			const productPrice = productCard.querySelector(".mm-pc-price");
			const selectedPrice = selectedVariant.dataset.price;
			const priceFormatted = selectedPrice / 100
			let euros = Math.floor(priceFormatted);
			let cents = Math.round((priceFormatted - euros) * 100);
			productPrice.innerHTML = euros + "€" + (cents > 0 ? cents : "");

			//change selector qtty
			const quantity_in_cart = selectedVariant.dataset.cartQtty;
			if (quantity_in_cart) {
				productCard.querySelector(".quantity__input").innerText = quantity_in_cart;

				productCard.querySelector(".mm-quit-buy-container").classList.add("mm-styl-transition");
				productCard.querySelector(".mm-qb-btn-text").style.removeProperty("display");
				productCard.querySelector(".mm-pc-cta-container").style.display = "none";
				if (quantity_in_cart == 1) {
					productCard.querySelector(".mm-pc-delete-icon").style.removeProperty("display");
					productCard.querySelector(".mm-pc-minus-icon").style.display = "none";
				} else {
					productCard.querySelector(".mm-pc-minus-icon").style.removeProperty("display");
					productCard.querySelector(".mm-pc-delete-icon").style.display = "none";
				}
			} else {
				productCard.querySelector(".mm-quit-buy-container").classList.remove("mm-styl-transition");
				productCard.querySelector(".mm-pc-cta-container").style.removeProperty("display");
				productCard.querySelector(".mm-qb-btn-text").style.display = "none";
			}
		})
	})
}

document.addEventListener("DOMContentLoaded", initializeVariantSelectors);



// Klaviyo Web Push - Configuration

document.addEventListener("DOMContentLoaded", function () {
  console.log("🚀 Initialisation Web Push...");

  // Détecter l'email dans l'URL (pour identification Klaviyo)
  const urlParams = new URLSearchParams(window.location.search);
  const emailFromUrl = urlParams.get('utm_email');

  if (emailFromUrl) {
    console.log("📧 Email détecté dans l'URL:", emailFromUrl);
    // Si un email est dans l'URL, identifier le client dans Klaviyo
    if (typeof klaviyo !== 'undefined') {
      klaviyo.push(['identify', { $email: emailFromUrl }]);
      console.log("✅ Client identifié dans Klaviyo avec l'email");
    }
  }

  // Vérifier si l'utilisateur a déjà accepté ou refusé les notifications
  const permission = Notification.permission;
  console.log("📋 Permission actuelle des notifications:", permission);

  // Variable pour éviter de demander plusieurs fois
  let exitIntentShown = false;

  // Si l'utilisateur n'a pas encore répondu (permission = "default")
  if (permission === "default") {
    console.log("👋 Exit intent activé - la popup s'affichera quand vous essayerez de quitter la page");

    // Détecter quand l'utilisateur bouge sa souris vers le haut pour quitter
    document.addEventListener('mouseout', function(e) {
      // Détecter si la souris sort du document vers le haut
      // e.relatedTarget === null signifie que la souris sort du document
      // e.clientY < 10 signifie que la souris est proche du haut
      if (!exitIntentShown && !e.relatedTarget && e.clientY < 10) {
        exitIntentShown = true;
        console.log("🚪 Exit intent détecté ! (souris vers le haut)");
        subscribeToPush();
      }
    });

    // Alternative pour mobile : détecter le scroll rapide vers le haut
    let lastScrollTop = 0;
    window.addEventListener('scroll', function() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Si l'utilisateur est en haut de la page (scrollTop < 10) et scroll rapidement vers le haut
      if (scrollTop < 10 && scrollTop < lastScrollTop && !exitIntentShown) {
        exitIntentShown = true;
        console.log("🚪 Exit intent détecté ! (scroll vers le haut)");
        subscribeToPush();
      }

      lastScrollTop = scrollTop;
    }, false);

  } else if (permission === "granted") {
    console.log("✅ Notifications déjà autorisées");
  } else if (permission === "denied") {
    console.log("❌ Notifications refusées par l'utilisateur");
  }

  // DEBUG : Vérifier si le bouton existe dans le DOM
  setTimeout(() => {
    const testBtn = document.getElementById("button_id_here");
    console.log("🔍 DEBUG - Bouton trouvé dans le DOM:", testBtn);
    console.log("🔍 DEBUG - Style display du bouton:", testBtn?.style.display);
    console.log("🔍 DEBUG - Type de Klaviyo:", typeof klaviyo);
  }, 500);

  // Vérifier l'identification Klaviyo et activer le bouton
  if (typeof klaviyo !== 'undefined' && klaviyo.isIdentified) {
    klaviyo.isIdentified().then((isIdentified) => {
      console.log("🔍 DEBUG - Client identifié?", isIdentified);
      if (isIdentified) {
        console.log("✅ Client identifié - activation du bouton");
        // Client identifié - activer le bouton d'inscription aux notifications web push
        const subscribeBtn = document.getElementById("button_id_here");
        console.log("🔍 DEBUG - Bouton récupéré:", subscribeBtn);
        if (subscribeBtn) {
          subscribeBtn.style.display = "flex";
          subscribeBtn.style.visibility = "visible";
          subscribeBtn.style.opacity = "1";
          console.log("🔔 Bouton d'inscription aux notifications activé");
          console.log("🔍 DEBUG - Style après activation:", subscribeBtn.style.display);
        } else {
          console.log("⚠️ Bouton non trouvé dans le DOM");
        }
      } else {
        console.log("❌ Customer not identified.");
      }
    }).catch((error) => {
      console.error("Erreur Klaviyo:", error);
    });
  } else {
    console.log("⏳ Klaviyo pas encore chargé, vérification dans 1 seconde...");
    setTimeout(() => {
      if (typeof klaviyo !== 'undefined' && klaviyo.isIdentified) {
        klaviyo.isIdentified().then((isIdentified) => {
          console.log("🔍 DEBUG (après délai) - Client identifié?", isIdentified);
          if (isIdentified) {
            const subscribeBtn = document.getElementById("button_id_here");
            console.log("🔍 DEBUG (après délai) - Bouton trouvé:", subscribeBtn);
            if (subscribeBtn) {
              subscribeBtn.style.display = "flex";
              subscribeBtn.style.visibility = "visible";
              subscribeBtn.style.opacity = "1";
              console.log("🔔 Bouton d'inscription aux notifications activé (après délai)");
            }
          }
        });
      }
    }, 1000);
  }

  // Register service worker (chemin correct pour Shopify)
  if ('serviceWorker' in navigator) {
    // Utiliser l'URL du service worker depuis theme.liquid, ou fallback sur /assets/sw.js
    const swUrl = window.serviceWorkerUrl || '/assets/sw.js';

    console.log("🔧 Enregistrement du service worker:", swUrl);

    navigator.serviceWorker
      .register(swUrl)
      .then((reg) => {
        console.log("✅ Service Worker Registered!", reg);
        console.log("✅ Service Worker state:", reg.installing ? 'installing' : reg.waiting ? 'waiting' : reg.active ? 'active' : 'unknown');
        console.log("✅ Service Worker scope:", reg.scope);

        // Si le service worker est en cours d'installation, attendre qu'il soit activé
        if (reg.installing) {
          console.log("⏳ Service worker en cours d'installation...");
          reg.installing.addEventListener('statechange', function() {
            console.log("🔄 Service worker state changed:", this.state);
          });
        }
      })
      .catch((err) => {
        console.error("❌ Service Worker registration failed:", err);
      });
  } else {
    console.error("❌ Service Worker non supporté par ce navigateur");
  }

  // Function to handle push notification subscription
  async function subscribeToPush() {
    console.log("🎯 Fonction subscribeToPush appelée - début");

    try {
      // Vérifier le support des notifications
      if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        console.error("❌ Notifications non supportées par ce navigateur");
        alert("Votre navigateur ne supporte pas les notifications web push.");
        return;
      }

      console.log("✅ Navigateur supporte les notifications");

      // Demander la permission AVANT d'attendre le service worker
      console.log("⏳ Demande de permission...");
      const permission = await Notification.requestPermission();
      console.log("📋 Permission reçue:", permission);

      if (permission !== "granted") {
        console.log("❌ Permission refusée");
        alert("Vous avez refusé les notifications. Veuillez les autoriser dans les paramètres de votre navigateur.");
        return;
      }

      console.log("✅ Permission accordée");
      console.log("⏳ Recherche du service worker...");

      // Vérifier si un service worker est déjà enregistré
      let registration = await navigator.serviceWorker.getRegistration();

      if (!registration) {
        console.log("⏳ Aucun service worker trouvé, nouvel enregistrement...");
        const swUrl = window.serviceWorkerUrl || '/assets/sw.js';
        // Ne pas spécifier de scope - laisser le scope par défaut (celui autorisé par Shopify)
        registration = await navigator.serviceWorker.register(swUrl);
        console.log("✅ Service worker enregistré avec scope:", registration.scope);

        // Attendre un peu que le service worker s'active
        await new Promise(resolve => setTimeout(resolve, 2000));
      } else {
        console.log("✅ Service worker déjà enregistré avec scope:", registration.scope);
      }

      console.log("✅ Service worker trouvé:", registration);
      console.log("⏳ Création de la subscription...");

      if (permission !== "granted") {
        console.log("❌ Permission denied. Please allow notifications.");
        alert("Vous avez refusé les notifications. Veuillez les autoriser dans les paramètres de votre navigateur.");
        return;
      }

      console.log("✅ Permission accordée, inscription en cours...");

      // Subscribe to push notifications
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: "BOvc0gckdIVxeYyOxSHgqKykfrK_2xaAFzWyE9x0tiPHx2PZDq-XYnDAVtXq45fIHOG9kzFUdLqPMw0SI-uOUZI",
      });

      console.log("✅ Subscription créée:", subscription);

      // Extract keys safely
      const keys = extractKeys(subscription);
      console.log("🔑 Clés extraites:", keys);

      if (!keys) {
        throw new Error("Push subscription keys are missing.");
      }

      // Send subscription data to Klaviyo
      registerPushInKlaviyo(keys, subscription.endpoint);
      console.log("✅ Successfully subscribed to push notifications!");
      alert("Vous êtes maintenant abonné aux notifications !");

    } catch (error) {
      console.error("❌ Subscription failed:", error);
      alert("Erreur lors de l'inscription: " + error.message);
    }
  }

  // Attach click event to subscribe button (si le bouton existe)
  setTimeout(() => {
    const subscribeBtn = document.getElementById("button_id_here");
    console.log("🔍 Recherche du bouton pour ajouter l'event listener...");
    console.log("🔍 Bouton trouvé:", subscribeBtn);

    if (subscribeBtn) {
      subscribeBtn.addEventListener("click", function(e) {
        console.log("👆 CLIC sur le bouton détecté !");
        subscribeToPush();
      });
      console.log("✅ Event listener ajouté au bouton");
    } else {
      console.log("⚠️ Bouton non trouvé pour ajouter l'event listener");
    }
  }, 2000); // Attendre 2 secondes pour être sûr que le bouton est dans le DOM
});

function extractKeys(subscription) {
    try {
      const jsonSubscription = subscription.toJSON();
      if (jsonSubscription.keys) {
        return {
          p256dh: jsonSubscription.keys.p256dh,
          auth: jsonSubscription.keys.auth,
        };
      }
    } catch (error) {
      console.error("Error extracting keys:", error);
    }
    return null;
  }

  function registerPushInKlaviyo(keys, endpoint) {
    klaviyo.identify({
      "Web Push Notification": "Subscribed",
      web_push__endpoint: endpoint,
      web_push__auth: keys.auth,
      web_push__p256dh: keys.p256dh,
    });

    klaviyo.push([
      "track",
      "Subscribed to Web Push",
      {
        url: window.location.href,
        web_push__endpoint: endpoint,
        web_push__auth: keys.auth,
        web_push__p256dh: keys.p256dh,
      },
    ]);
  }